// export const FRONT_URL = "http://localhost:3000";
export const FRONT_URL = "https://evolution.espochic.com/";
// export const API_URL = "http://localhost:3000";
export const API_URL = "https://evolution.espochic.com/api";
// export const SOCKET_URL = "http://localhost:1337";
export const SOCKET_URL = "https://evolution.espochic.com";
export const TOKEN_KEY = "strapi-jwt-token";

